/**
 * Minimum amount of segmentation input expected to apply dynamic collection
 * for audience B
 * */
export const MINIMUM_INPUT_CDP = 2;

/** Default tracking name for dynamic stand alone cdp  */
export const DEFAULT_DYNAMIC_CDP_NAME = 'dynamic-cdp';
